const topMenuColor = '#2a2c2e';
const topSubMenuColor = '#3a3d40';
const subMenuDividerColor = 'rgba(255,255,255,.1)';

export default {
  topMenuColor,
  topSubMenuColor,
  subMenuDividerColor,
};
